import { nutritionTargetsClient } from "../api/ApiClients";
import {
  ISetNutritionTargetsCommand,
  SetNutritionTargetsCommand,
  IRemoveNutritionTargetsCommand,
  RemoveNutritionTargetsCommand,
  ISetPreferredTargetCommand,
  SetPreferredTargetCommand,
  DeleteMigrationHiddenTargetCommand,
} from "@growth-machine-llc/stridist-api-client";
import ServiceBase from "./ServiceBase";

class NutritionEntriesService extends ServiceBase {
  async getNutritionTargets(clientUsername: string) {
    return nutritionTargetsClient.getNutritionTargets(clientUsername);
  }

  async getHiddenTargets(clientUsername: string) {
    return nutritionTargetsClient.getMigrationHiddenTargets(clientUsername);
  }

  async deleteHiddenTarget(id: number) {
    const command = DeleteMigrationHiddenTargetCommand.fromJS({
      id,
    });
    return nutritionTargetsClient.deleteMigrationHiddenTarget(command);
  }

  async getRecomendedTarget(
    username: string,
    year: number,
    month: number,
    day: number,
  ) {
    return nutritionTargetsClient.getRecomendedTarget(
      year,
      month,
      day,
      username,
    );
  }

  async getRecomendedTargetList(
    username: string,
    startYear: number,
    startMonth: number,
    startDay: number,
    endYear: number,
    endMonth: number,
    endDay: number,
  ) {
    return nutritionTargetsClient.getRecomendedTargetList(
      startYear,
      startMonth,
      startDay,
      endYear,
      endMonth,
      endDay,
      username,
    );
  }

  async setNutritionTargets(variables: ISetNutritionTargetsCommand) {
    const command = SetNutritionTargetsCommand.fromJS(variables);

    return nutritionTargetsClient.setNutritionTargets(command);
  }

  async removeNutritionTargets(variables: IRemoveNutritionTargetsCommand) {
    const command = RemoveNutritionTargetsCommand.fromJS(variables);

    return nutritionTargetsClient.removeNutritionTargets(command);
  }

  async setPreferedTarget(variables: ISetPreferredTargetCommand) {
    const command = SetPreferredTargetCommand.fromJS(variables);

    return nutritionTargetsClient.setPreferredTarget(command);
  }
}

export default new NutritionEntriesService();
